import { Component, OnInit } from '@angular/core'
import { FormBuilder } from '@angular/forms'
import { BuilderService } from '../../../builder-services/builder.service'
import { PagesService } from 'src/app/pages/website-builder/pages.service'
import { WebsiteTemplatesService } from '../website-templates.service'

@Component({
  selector: 'website-templates',
  templateUrl: './website-templates.component.html',
  styleUrls: ['./website-templates.component.scss']
})
export class WebsiteTemplatesComponent implements OnInit {
  templatesForm: any = this.formBuilder.group({
    templateName: '',
    templateSelected: '',
    templateImage: '',
    templateCategorySelected: ''
  })
  templatesList: Array<any> = []
  templateImageSrc = ''
  templateName = ''
  templateId = ''
  templateCategorySelected = ''
  mobile = false
  templatesCategories = [
    {
      id: 'restaurants',
      name: 'Restaurants'
    },
    {
      id: 'fashion',
      name: 'Fashion'
    },
    {
      id: 'grocery',
      name: 'Grocery & Market'
    },
    {
      id: 'electronics',
      name: 'Electronics'
    },
    {
      id: 'pharmacies',
      name: 'Pharmacies'
    },
    {
      id: 'general',
      name: 'General'
    }
  ]
  showTemplatesProgress = false

  constructor(
    private formBuilder: FormBuilder,
    private builderService: BuilderService,
    private pagesService: PagesService,
    private websiteTemplatesService: WebsiteTemplatesService
  ) {
    this.getAllTemplates()
  }

  ngOnInit(): void {
    if (window.screen.width <= 768) {
      // 768px portrait
      this.mobile = true
    }
  }

  /**
   * Get all the templates to be rendered in the Drop Down Menu
   */
  getAllTemplates = () => {
    this.templatesList = []
    this.websiteTemplatesService.getTemplates().subscribe((templates: any) => {
      for (const key in templates) {
        if (Object.prototype.hasOwnProperty.call(templates, key)) {
          const element = templates[key]
          element.template_id = key
          this.templatesList.push(element)
        }
      }
      console.log('Website Templates:', this.templatesList)
    })
  }

  onSubmit = ($event: any) => {
    const projectId = this.builderService.selectedProject

    // Get all pages from the current project
    Promise.all([
      this.pagesService.getProjectPages(String(projectId)),
      this.pagesService.getStaticBlock(String(projectId), 'header').toPromise(),
      this.pagesService.getStaticBlock(String(projectId), 'footer').toPromise()
    ]).then(([pages, headerData, footerData]) => {
      // Check if creating new template or updating existing
      if ($event.submitter.classList.contains('createTemplate')) {
        // Create new template
        this.websiteTemplatesService.insertTemplate(
          this.templatesForm.value.templateName,
          this.templateImageSrc,
          pages || {},
          headerData || {},
          footerData || {}
        ).subscribe(() => {
          alert('Template created successfully!')
          this.getAllTemplates()
        })
      } else {
        // Update existing template
        const templateID = this.templatesList[this.templatesForm.value.templateSelected].template_id
        this.websiteTemplatesService.updateTemplate(
          templateID,
          this.templatesForm.value.templateName,
          this.templateImageSrc,
          pages || {},
          headerData || {},
          footerData || {}
        ).subscribe(() => {
          alert('Template updated successfully!')
          this.getAllTemplates()
        })
      }
    })
  }

  queryChange($event: any, type: string) {
    let data = 0
    if (type == 'select') {
      data = $event.value
    } else if (type == 'text') {
      data = $event.currentTarget.value - 1
    } else if (type == 'slider') {
      data = $event.currentTarget.value - 1
    }
    console.log(this.templatesList[data])
    this.templateName = this.templatesList[data].template_name
    this.templateImageSrc = this.templatesList[data].template_image
    this.templateId = this.templatesList[data].template_id
    this.templateCategorySelected = this.templatesList[data].category

    this.templatesForm.value.templateName = this.templateName
    this.templatesForm.value.templateImageSrc = this.templateImageSrc
  }

  processFile(fileInput: any, type: string, name: string) {
    const file: File = fileInput.target.files[0]
    const reader = new FileReader()
    reader.addEventListener('load', (event: any) => {
      this.builderService.uploadImage(file, 'admin', 'website-templates').subscribe((imageResponse) => {
        this.templateImageSrc = imageResponse
        this.builderService.showUpdateProgress = false
      })
    })

    reader.readAsDataURL(file)
  }

  deleteTemplate = () => {
    const selectedIndex = this.templatesForm.value.templateSelected
    if (selectedIndex === '' || selectedIndex === undefined || selectedIndex === null) {
      alert('Please select a template to delete')
      return
    }

    const templateID = this.templatesList[selectedIndex].template_id
    const templateName = this.templatesList[selectedIndex].template_name

    if (!confirm(`Are you sure you want to delete the template "${templateName}"?`)) {
      return
    }

    this.showTemplatesProgress = true
    this.websiteTemplatesService.deleteTemplate(templateID).subscribe(
      (response) => {
        alert('Template deleted successfully!')
        this.showTemplatesProgress = false
        this.getAllTemplates()
        this.templateName = ''
        this.templateImageSrc = ''
        this.templateId = ''
        this.templateCategorySelected = ''
        this.templatesForm.reset()
      },
      (error) => {
        console.error('Error deleting template:', error)
        alert('Error deleting template. Please try again.')
        this.showTemplatesProgress = false
      }
    )
  }
}
